/**
 * Яндекс.Метрика и Google Tag Manager в SPA: сами счётчики подключены в index.html,
 * а здесь отправляем просмотр при смене адреса — страница не перезагружается, и без этого
 * обе системы засчитали бы только первый заход.
 */
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { captureCampaign, METRIKA_COUNTER_ID } from "@/shared/lib/analytics";

declare global {
	interface Window {
		ym?: (...args: unknown[]) => void;
		dataLayer?: Record<string, unknown>[];
	}
}

export const YandexGoogleMetrics = () => {
	const { pathname, search, hash } = useLocation();
	const pagePath = pathname + search + hash;
	const url = window.location.origin + pagePath;
	const lastUrl = useRef<string | null>(null);

	useEffect(() => {
		captureCampaign(search);
		// Первый просмотр уже засчитали init в index.html (и gtm.js для GTM)
		if (lastUrl.current !== null && lastUrl.current !== url) {
			window.ym?.(METRIKA_COUNTER_ID, "hit", url, { referer: lastUrl.current });
			window.dataLayer?.push({
				event: "page_view",
				page_location: url,
				page_path: pagePath,
				page_referrer: lastUrl.current,
			});
		}
		lastUrl.current = url;
	}, [url, pagePath, search]);

	return null;
};
